import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { useHeaderFooter } from "@/lib/headerFooter";

const A = ({ to, children, ...p }) => (/^https?:/.test(to || "") ? <a href={to} target="_blank" rel="noreferrer" {...p}>{children}</a> : <Link to={to || "/"} {...p}>{children}</Link>);
const lk = "text-slate-400 hover:text-accent transition-colors";

export default function Footer() {
  const hf = useHeaderFooter();
  const f = hf?.footer;
  if (!f) return <footer className="mt-20 bg-steel min-h-[220px]" />;
  const c = f.contact || {};
  const cols = 1 + f.columns.length + 1;
  return (
    <footer className="mt-20 bg-steel text-slate-300" data-testid="site-footer">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 sm:grid-cols-2 ${cols >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"} ${cols >= 5 ? "xl:grid-cols-5" : ""}`}>
        <div>
          {f.about_title && <div className="font-heading font-extrabold text-xl text-white tracking-wide" data-testid="footer-about-title">{f.about_title}</div>}
          {f.about_text && <p className="mt-3 text-sm text-slate-400 max-w-xs whitespace-pre-line" data-testid="footer-about-text">{f.about_text}</p>}
        </div>
        {f.columns.map((col, i) => (
          <div key={col.id} className="text-sm" data-testid={`footer-col-${i}`}>
            <div className="font-semibold text-white mb-2">{col.title}</div>
            {col.type === "text"
              ? <p className="text-slate-400 whitespace-pre-line">{col.text}</p>
              : <ul className="space-y-2">{col.links.map((l) => <li key={l.id}><A to={l.link} className={lk} data-testid={`footer-link-${l.id}`}>{l.label}</A></li>)}</ul>}
          </div>))}
        {(c.email || c.phone || c.address || c.hours) && (
          <div className="text-sm space-y-2" data-testid="footer-contact">
            <div className="font-semibold text-white mb-2">{c.title || "Contact"}</div>
            {c.email && <a href={`mailto:${c.email}`} className={`flex items-center gap-2 ${lk}`}><Mail size={14} className="shrink-0" />{c.email}</a>}
            {c.phone && <a href={`tel:${c.phone.replace(/\s/g, "")}`} className={`flex items-center gap-2 ${lk}`}><Phone size={14} className="shrink-0" />{c.phone}</a>}
            {c.address && <p className="flex items-start gap-2 text-slate-400 whitespace-pre-line"><MapPin size={14} className="shrink-0 mt-0.5" />{c.address}</p>}
            {c.hours && <p className="flex items-start gap-2 text-slate-400"><Clock size={14} className="shrink-0 mt-0.5" />{c.hours}</p>}
          </div>)}
      </div>
      <div className="border-t border-steel-light py-4 px-4 text-center text-xs text-slate-500" data-testid="footer-bottom">
        © {new Date().getFullYear()} {f.bottom_text}
      </div>
    </footer>
  );
}
